import { Instance } from 'mobx-state-tree';
import { BillingCycleUpdatedDtoModelBase } from './BillingCycleUpdatedDtoModel.base';

/* The TypeScript type of an instance of BillingCycleUpdatedDtoModel */
export interface BillingCycleUpdatedDtoModelType extends Instance<typeof BillingCycleUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for BillingCycleUpdatedDtoModel */
export { selectFromBillingCycleUpdatedDto, billingCycleUpdatedDtoModelPrimitives, BillingCycleUpdatedDtoModelSelector } from './BillingCycleUpdatedDtoModel.base';

/**
 * BillingCycleUpdatedDtoModel
 */
export const BillingCycleUpdatedDtoModel = BillingCycleUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
